import { render, staticRenderFns } from "./DeleteDiagnosticModal.vue?vue&type=template&id=7153cb16&scoped=true"
import script from "./DeleteDiagnosticModal.vue?vue&type=script&lang=js"
export * from "./DeleteDiagnosticModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteDiagnosticModal.vue?vue&type=style&index=0&id=7153cb16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7153cb16",
  null
  
)

export default component.exports